import * as ApiBase from '../../APIBase'
import {
  emailVerificationInProgess,
  invalidateVerifiedEmail,
  updateAPIActionFeedback,
  updateCustomerInfo,
  verifyCustomerEmailAddress,
} from '.'
import { setUserName } from '../../Account/actions'
import { updateActionMessage } from '../../shared/actionFeedback/actions'

export const getMyProfileInfo = () => async (dispatch, getState) => {
  const subPath = getState().merchant.canonical_name
  const token = getState().user.accessToken
  const URL = `/${subPath}/customer/profile`

  const json = await ApiBase.get(URL, {}, token)

  dispatch(updateCustomerInfo(json.profile_info))
}

export const verifyEmailAddress = (email) => async (dispatch, getState) => {
  dispatch(emailVerificationInProgess(true))

  const subPath = getState().merchant.canonical_name
  const URL = `/${subPath}/customer/status`
  const token = getState().user.accessToken

  let json = {}
  json = await ApiBase.get(URL, { email }, token)
  const addressExists = {
    message: 'Email address already exists',
    success: false,
  }

  if (json.status === 'account_exists') {
    dispatch(verifyCustomerEmailAddress())
    dispatch(updateAPIActionFeedback(true))
    dispatch(updateActionMessage(addressExists))
  } else {
    dispatch(invalidateVerifiedEmail())
    dispatch(updateAPIActionFeedback(false))
    dispatch(updateActionMessage({
      message: '',
      success: true,
    }))
  }
  setTimeout(() => {
    dispatch(emailVerificationInProgess(false))
  }, 100)
  return json
}

export const updateMyProfileInfo = (params) => async (dispatch, getState) => {
  const subPath = getState().merchant.canonical_name
  const token = getState().user.accessToken
  const URL = `/${subPath}/customer/profile`

  const json = await ApiBase.put(URL, params, token)

  const infos = {
    ...json.profile_info,
    country_code: params.country_code,
  }
  if (json.success) {
    dispatch(updateCustomerInfo(infos))
  }

  dispatch(updateAPIActionFeedback(true))

  dispatch(updateActionMessage({
    message: json.message,
    success: json.success,
  }))

  setTimeout(() => {
    dispatch(updateAPIActionFeedback(false))
    dispatch(updateActionMessage({
      message: '',
      success: json.success,
    }))
  }, 5000)

  dispatch(setUserName(params.first_name))
}
